export const UNSUPPORTED_BROWSER_BANNER_DISMISSED_KEY = 'unsupportedBrowserBanner.dismissed';
